import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import LondrisoftAgileMS from '../views/LondrisoftAgileMS.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/LondrisoftAgileMS',
    name: 'LondrisoftAgileMS',
    component: LondrisoftAgileMS
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
